/**
 * @remix-run/cloudflare-workers v1.2.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { installGlobals } from './globals.js';
export { createCloudflareKVSessionStorage } from './sessions/cloudflareKVSessionStorage.js';
export { createEventHandler, createRequestHandler, handleAsset } from './worker.js';

installGlobals();
